/**
 * @generated SignedSource<<e74169aa5819da6157189631dac8e61f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type UpdateRowInput = {
  clientMutationId?: string | null;
  rowId: string;
  text?: string | null;
};
export type Row_UpdateRow_Mutation$variables = {
  input: UpdateRowInput;
};
export type Row_UpdateRow_Mutation$data = {
  readonly updateRow: {
    readonly row: {
      readonly id: string;
      readonly text: string;
    } | null;
  } | null;
};
export type Row_UpdateRow_Mutation = {
  response: Row_UpdateRow_Mutation$data;
  variables: Row_UpdateRow_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateRowPayload",
    "kind": "LinkedField",
    "name": "updateRow",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "RowNode",
        "kind": "LinkedField",
        "name": "row",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "text",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "Row_UpdateRow_Mutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "Row_UpdateRow_Mutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "8b6e1b4dc125fd920453162d268eb816",
    "id": null,
    "metadata": {},
    "name": "Row_UpdateRow_Mutation",
    "operationKind": "mutation",
    "text": "mutation Row_UpdateRow_Mutation(\n  $input: UpdateRowInput!\n) {\n  updateRow(input: $input) {\n    row {\n      id\n      text\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "b13552e83fbff65b69bdd74dd9f8a2de";

export default node;
